import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { PermissionCodeEnum } from '/@/enums/permissionCodeEnum';
import { STORAGE_KEY } from '/@/constants/storage';

const currentActiveMenu = RouteEnum.DATASETS_LIST;

const dataset: AppRouteModule = {
  path: RouteEnum.DATASETS,
  name: RouteEnum.DATASETS,
  component: LAYOUT,
  redirect: RouteEnum.DATASETS_LIST,
  meta: {
    hideChildrenInMenu: true,
    icon: 'dataset|svg',
    title: t('common.datasets'),
    orderNo: 10,
    // hideMenu: true,
    permCode: [PermissionCodeEnum.DATASET_QUERY],
  },
  children: [
    {
      path: 'list',
      name: RouteEnum.DATASETS_LIST,
      component: () => import('/@/views/datasets/datasetList/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
    {
      path: 'trash',
      name: RouteEnum.DATASETS_TRASH,
      component: () => import('/@/views/datasets/datasetList/index.vue'),
      meta: {
        title: t('common.trash'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'data',
      name: RouteEnum.DATASETS_DATA,
      component: () => import('/@/views/datasets/datasetContent/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.data'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'qa-data',
      name: RouteEnum.DATASETS_QA_DATA,
      component: () => import('/@/views/datasets/datasetContent/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.data'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'overview',
      name: RouteEnum.DATASETS_OVERVIEW,
      component: () => import('/@/views/datasets/overView/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.overview'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'rules',
      name: RouteEnum.DATASETS_RULES,
      component: () => import('/@/views/datasets/QA/Rules.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.QA'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'QualityCheckJobs',
      name: RouteEnum.DATASETS_QUA_CHECK_JOBS,
      component: () => import('/@/views/datasets/QA/QualityCheckJobs.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.QualityCheckJobs'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'createRun',
      name: RouteEnum.DATASETS_CREATE_RUN,
      component: () => import('/@/views/datasets/QA/createRun.vue'),
      meta: {
        title: t('common.createRun'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'report',
      name: RouteEnum.DATASETS_REPORT,
      component: () => import('/@/views/datasets/QA/Report.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.report'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    // ontology 子模块
    {
      path: 'class',
      name: RouteEnum.DATASETS_CLASS,
      component: () => import('/@/views/datasets/datasetOntology/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.ontology'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
    {
      path: 'classification',
      name: RouteEnum.DATASETS_CLASSIFICATION,
      component: () => import('/@/views/datasets/datasetOntology/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        sessionInfo: STORAGE_KEY.breadcrumbType,
        title: t('common.ontology'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: currentActiveMenu,
      },
    },
  ],
};

export default dataset;
